import React, { useState, useContext, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import axios from '../../../../axios/index';

// Context
import { UserContext } from '../../../Context/UserContextProvider';

// styles 
import styles from "./AddCategory.module.css"
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"
import uploadImgStyles from "../../DashboardReuseAbleComponents/AddNewFiles/UploadFileImages.module.css"
import 'react-toastify/dist/ReactToastify.css';

// Re Useable Components
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import ImageUploading from "react-images-uploading";
import { addCategoryValidate } from './addCategoryValidate';

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg"
import addIcon from "../../../../assets/img/DashboardICons/CircleAddIconBlue.svg"
import portraitIcon from "../../../../assets/img/DashboardICons/PortraitIcon.svg"
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg"

const AddCategory = (props) => {
    const { userToken } = useContext(UserContext);
    const [image, setImage] = useState([]);
    const [btnLoader, setBtnLoader] = useState(false)
    const [errors, setErrors] = useState({})
    const maxNumber = 1;
    const history = useHistory()
    const [addCategoryData, setAddCategoryData] = useState({
        categoryName: "",
        slug: ""
    })

    useEffect(() => {
        setErrors(addCategoryValidate(addCategoryData))
    }, [addCategoryData])

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover={false}
                            theme="light"
                        />
                        <form onSubmit={(e) => e.preventDefault()} className={`mt-3 px-0 ${Dstyles.container}`}>
                            <DashboardHeader />
                            {/* title */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                            <a href='#' onClick={history.goBack}><img className='ms-2 pointer' src={arrowIcon} alt="icon" /></a>
                                            <div className={Dstyles.text1}>
                                                افزودن دسته‌بندی
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* title */}

                            {/* row1 input category name */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >

                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start mb-4'>
                                            <div className={`mb-3 ${styles.input_header}`}>
                                                عنوان دسته‌بندی
                                            </div>
                                            <input
                                                type="text"
                                                name="categoryName"
                                                value={addCategoryData.categoryName}
                                                onChange={changeHandler}
                                                className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                                            // placeholder="مثلا اپارتمان ۳۰۰ متر تختی"
                                            />
                                            <div className={styles.text_danger}>
                                                لطفا در عنوان نوع دسته بندی را ذکر نمایید(فروش/اجاره)
                                            </div>
                                        </div>
                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start mt-3 mb-4'>
                                            <div className={`mb-3 ${styles.input_header}`}>
                                                عنوان دسته‌بندی(انگلیسی)
                                            </div>
                                            <input
                                                type="text"
                                                name="slug"
                                                pattern="[a-zA-Z]"
                                                value={addCategoryData.slug}
                                                onChange={changeHandler}
                                                className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                                            // placeholder="مثلا اپارتمان ۳۰۰ متر تختی"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* row1 input category name */}

                            {/* add icon */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >
                                        <div className='d-flex flex-column justify-content-center align-items-start flex-wrap'>
                                            <div className={`mb-4 ${uploadImgStyles.title_bold}`}>
                                                افزودن آیکون دسته‌بندی
                                            </div>
                                            <div className="d-flex align-items-center justify-content-center mb-5">
                                                <div className={`ms-2 ${uploadImgStyles.circle_green}`}></div>
                                                <div className={uploadImgStyles.title_sm_gray}>
                                                    آیکون مورد نظر خود را برای دسته‌بندی اضافه کنید
                                                </div>
                                            </div>
                                            <ImageUploading
                                                multiple
                                                value={image}
                                                onChange={onChange}
                                                maxNumber={maxNumber}
                                                dataURLKey="data_url"
                                            >
                                                {({
                                                    imageList,
                                                    onImageUpload,
                                                    onImageRemove,
                                                    dragProps
                                                }) => (
                                                    // write your building UI
                                                    <div className='w-100 d-flex align-items-center flex-wrap'>
                                                        {imageList.map((image, index) => (
                                                            <div key={index} className={`d-flex flex-column align-items-center justify-content-center my-4 ms-4 ${uploadImgStyles.uploaded_img_container}`}>
                                                                <img className={uploadImgStyles.uploaded_img} src={image.data_url} alt="uploaded-img" />
                                                                <div className={uploadImgStyles.remove_img_container}>
                                                                    <img onClick={() => onImageRemove(index)} src={trashIcon} alt="icon" />
                                                                </div>
                                                            </div>
                                                        ))}

                                                        <div className={`d-flex align-items-center justify-content-center ${uploadImgStyles.upload_img_container}`}>
                                                            <div className="d-flex flex-column align-items-center justify-content-center position-relative">
                                                                <img src={portraitIcon} alt="icon" />
                                                                <img className={uploadImgStyles.add_icon} src={addIcon} alt="icon" onClick={onImageUpload}
                                                                    {...dragProps} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </ImageUploading>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* add icon */}

                            {/* Save Btn */}
                            <div className="py-2 mb-4">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-end justify-content-center flex-column'>
                                            {btnLoader ? (
                                                <div className={Dstyles.btn_loader_container}>
                                                    <div className={Dstyles.btn_spinner}></div>
                                                </div>
                                            )
                                                : (
                                                    <button type="submit" className={`btn ${styles.save_btn}`} onClick={submitHandler}>
                                                        ذخیره
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu addNewFile />
                        {/* sideMenu ends */}

                    </div>
                </div>
            </div>
        </>
    );

    function changeHandler(event) {
        if (event.target.name === "slug") {
            let value = event.target.value;
            value = value.replace(/[^A-Za-z-0-9]/gi, " ");
            setAddCategoryData((prev) => {
                return { ...prev, slug: value };
            });
        } else {
            setAddCategoryData((prev) => {
                return { ...prev, [event.target.name]: event.target.value };
            });
        }
    };

    async function onChange(imageList) {
        setImage(imageList);
    };

    function submitHandler() {
        if (!Object.keys(errors).length) {
            notify("درحال ایجاد دسته بندی جدید", "success")
        } else {
            notify("!لطفا تمام فیلد هارا پرکنید", "error")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            postHandler()
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    async function postHandler() {
        try {
            setBtnLoader(true)
            var data = new FormData();
            data.append('Title', addCategoryData.categoryName);
            data.append('Icon', image[0].file ? image[0].file : "icon",);
            data.append('Slug', addCategoryData.slug);
            data.append('SeoData.MetaTitle', addCategoryData.categoryName);
            data.append('SeoData.MetaDescription', addCategoryData.categoryName);
            data.append('SeoData.MetaKeyWords', addCategoryData.categoryName);
            data.append('SeoData.IndexPage', false);
            data.append('SeoData.Canonical', addCategoryData.categoryName);
            data.append('SeoData.Schema', addCategoryData.categoryName);
            data.append('ParentId', 0);

            const apiData = await axios.post(
                "Category",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            // console.log(apiData)
            history.push("/add-new-file");
            setBtnLoader(false)
        } catch (error) {
            notify("خطای سرور", "error")
            // console.log(error)
        }
    }
};

export default AddCategory;